import { render } from "./BusinessPage.vue?vue&type=template&id=d3c4fbe2&ts=true"
import script from "./BusinessPage.vue?vue&type=script&lang=ts"
export * from "./BusinessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__